var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('l-geoJson',{attrs:{"geojson":_vm.geoJson,"options":_vm.options,"optionsStyle":_vm.styleFunction}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }